import React from 'react';
import { usePermissions } from '@/app/permissions';
export const RequirePermission: React.FC<{ name: 'Punches' | 'Shifts' | 'Monthly bills' | 'Leave days' | 'Policies'; children: React.ReactNode }> = ({ name, children }) => {
  const perms = usePermissions(); if (!perms[name]) return null; return <>{children}</>;
};
